// extracted by mini-css-extract-plugin
module.exports = {"text_date":"textDate_text_date__19KQI"};